<template>
  <div>
    <NavBtns></NavBtns>

    <!--廣告首頁-->
    <section class="d-none d-xl-block" id="loa">
      <div class="locabox1" :class="{ hidden: ad_open }">
        <div class="locationTitle">
          {{ $t('message.qs_querysite') }}
          <h4>{{ $t('message.qs_realtime_vacacy') }}</h4>
        </div>
        <div class="locationA1">
          <img
            class="img-fluid"
            src="../assets/images/location_a01.svg"
            alt="OWLocker智慧型寄物櫃"
          />
        </div>
        <div class="locationA2">
          <img
            class="img-fluid"
            src="../assets/images/location_a02.svg"
            alt="OWLocker智慧型寄物櫃"
          />
        </div>
        <div class="locationA3">
          <img
            class="img-fluid"
            src="../assets/images/location_a03.svg"
            alt="OWLocker智慧型寄物櫃"
          />
        </div>
        <div class="locationA4" @click="ad_open = !ad_open">
          <img
            class="img-fluid"
            src="../assets/images/owl_ad.svg"
            alt="OWLocker智慧型寄物櫃"
          />
        </div>
        <div
          class="locationA5"
          @click="ad_open = !ad_open"
          :class="{ hidden: ad_open }"
        >
          <div class="box">
            <i class="fas fa-angle-double-left"></i>
            <span>{{ $t('message.qs_keykey_time') }}</span>
          </div>
        </div>
      </div>
    </section>

    <!--廣告內頁-->
    <AdBanners
      ad_type="querysite"
      ref="ad_banner"
      v-on:close-ad-banner="vCloseAdBanner"
    ></AdBanners>

    <!--地點分類查詢列-->
    <section id="lob">
      <div class="locationbox_b">
        <ul>
          <div class="locatbtext" :class="{ show: collapse_open }">
            {{ $t('message.qs_quick_assort') }}
            <li
              v-for="(co_unit, index) in nav_co_units"
              :class="{ active: co_unit.is_current }"
              v-bind:key="index"
            >
              <div class="fas"></div>
              <a href="#" @click.prevent="vFilterSite(index)">{{
                co_unit[$i18n.locale]
              }}</a>
            </li>
          </div>
        </ul>
      </div>
      <!--折疊按鈕-->
      <div
        class="openbtn"
        @click="collapse_open = !collapse_open"
        :class="{ show: collapse_open }"
      >
        <i class="fas fa-caret-down"></i>
      </div>
    </section>

    <!--資料區-->
    <section id="loc">
      <div class="container-fluid">
        <div class="row">
          <!--快速模式-->
          <div class="col-xl-12" v-if="!(is_offline || is_no_data)">
            <div class="loccheckbo">
              <div class="checkbox">
                <input id="a1" v-model="quick_mode" type="checkbox" />
                <span for="a1">{{ $t('message.qs_quick_mode') }}</span>
                <label for="a1"></label>
              </div>
            </div>
          </div>

          <div class="col-xl-12" v-if="!(is_offline || is_no_data)">
            <!--單一區域 : 北部 / 中部 / 南部-->
            <div
              class="row"
              v-for="(area, index) in filter_sites"
              v-bind:key="index"
            >
              <div class="col-xl-3">
                <div class="locatctext wow">
                  {{ area['area_i18n'][$i18n.locale] }}
                </div>
              </div>

              <!--地點明細-->
              <div class="col-xl-9 col-lg-12">
                <!--合作單位名稱-->
                <div
                  class="locatctitle"
                  v-for="(co_unit, unit_idx) in area['co_units']"
                  v-bind:key="unit_idx"
                >
                  {{ co_unit['co_unit_i18n'][$i18n.locale] }}
                  <!--尺寸 / icon 說明-->
                  <div class="circlebox" v-if="quick_mode">
                    <div class="size">{{ $t('message.qs_size') }}</div>
                    <div
                      class="box"
                      v-for="(locker_size, size_idx) in co_unit['provide_size']"
                      v-bind:key="size_idx"
                    >
                      <!--S / L-->
                      <div class="pay1" v-if="locker_size != 'M'">
                        {{ locker_size }}
                      </div>
                      <!--充電櫃-->
                      <div class="ibox" v-else>
                        <i class="fas fa-mobile-alt"></i>
                        <i class="fas fa-bolt"></i>
                      </div>
                      <div
                        class="slash"
                        v-if="size_idx < co_unit['provide_size'].length - 1"
                      >
                        /
                      </div>
                    </div>

                    <div class="box">
                      <div class="circle1"></div>
                      <div class="vtext">{{ $t('message.qs_vacancy') }}</div>
                    </div>
                  </div>

                  <!--站點明細-->
                  <div class="locorangebox" :class="{ show: quick_mode }">
                    <div class="lobuttonbox">
                      <button
                        v-for="(site, site_idx) in co_unit['sites']"
                        v-bind:key="site_idx"
                        @click="vReadyDetailWinContent(site)"
                      >
                        <a>{{ site['site_i18n'][$i18n.locale] }}</a>

                        <!--快速模式 / 後面的提示-->
                        <div class="circlebox" v-if="quick_mode">
                          <div
                            class="box"
                            v-for="(locker_type, type_idx) in site[
                              'lockers_type'
                            ]"
                            v-bind:key="type_idx"
                          >
                            <div
                              class="sizetext"
                              v-if="locker_type['size'] == 'M'"
                            >
                              <i class="fas fa-mobile-alt"></i>
                              <i class="fas fa-bolt"></i>
                            </div>
                            <div class="sizetext" v-else>
                              {{ locker_type['size'] }}
                            </div>

                            <div class="circle1">
                              <h5>{{ locker_type['empty'] }}</h5>
                            </div>
                            <div
                              class="slash"
                              v-if="type_idx < site['lockers_type'].length - 1"
                            >
                              /
                            </div>
                          </div>
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
                <!--區域結束水平線-->
                <hr v-if="index < filter_sites.length - 1" />
              </div>
            </div>
          </div>

          <!--離線顯示-->
          <div class="col-xl-12">
            <div class="offlinebox" :class="{ show: is_offline || is_no_data }">
              <div class="allbox">
                <div class="imgbox">
                  <img
                    class="img-fluid"
                    src="../assets/images/offline.svg"
                    alt="offline"
                  />
                </div>
                <div class="text">
                  {{
                    is_offline
                      ? $t('message.pb_offline')
                      : $t('message.qs_no_data')
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="spacebox"></div>
      </div>
    </section>

    <!--站點視窗-->
    <QsWin
      ref="qs_win"
      :open_win="open_win"
      :click_site_no="click_site"
      v-on:open-window="vOpenDetailWin"
      v-on:close-window="vCloseDetailWin"
    ></QsWin>

    <!--頁尾-->
    <GzFooter></GzFooter>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import $ from 'jquery';
import { WOW } from 'wowjs';

import NavBtns from '@/components/NavBtns.vue';
import AdBanners from '@/components/AdBanners.vue';
import QsWin from '@/components/QsWin.vue';
import GzFooter from '@/components/GzFooter.vue';
import Public from '@/scripts/public';

export default {
  name: 'Querysite',
  components: {
    NavBtns,
    AdBanners,
    QsWin,
    GzFooter,
  },
  data: function () {
    return {
      locations_api: Public.appGetAPIURL('location'),
      //綁定事件註記
      event_bind: false,
      //是否播放廣告
      ad_open: false,
      //地點導覽列 - 折疊按鈕
      collapse_open: false,
      //快速模式
      quick_mode: false,
      //開啟據點詳細資訊視窗
      open_win: false,
      //n秒後自動播放廣告
      i_auto_paly_ad_after_sec: 5000,
      wait_auto_paly_ad_timer: null,
      //站點資料(從後台拉回的原始數據)
      origin_sites: [
        // {
        // 	"co_unit_i18n" 	: {
        // 		"zh-TW" : "戲苑科技",
        // 		"en-US" : "GameZone Techology"
        // 	},
        // 	"sites"			: [
        // 		{
        // 			"area_i18n" 	: {
        // 				"zh-TW" : "中部地區",
        // 				"en-US" : "Central Area"
        // 			},
        // 			"site_i18n" 	: {
        // 				"zh-TW" : "戲苑科技",
        // 				"en-US" : "GameZone Techology"
        // 			},
        // 			"site_no" 		: "001",
        // 			"lockers_type"	: [
        // 				{
        // 					"size"	: "S",
        // 					"total"	: 0,
        // 					"empty"	: 0
        // 				},
        // 				{
        // 					"size"	: "L",
        // 					"total"	: 0,
        // 					"empty"	: 0
        // 				}
        // 			],
        // 			"updated_at"	: "1990-01-01 00:00"
        // 		}
        // 	]
        // }
      ],
      //地點導覽資訊
      nav_co_units: [
        {
          'zh-TW': '全部',
          'en-US': 'All',
          is_current: true,
        },
      ],
      //地點明細排序順序
      list_sort: ['北', '中', '南', '離島'],
      //地點明細資訊(篩選後，UI 讀取的來源)
      /*
		[
			//北部地區
			{
				"area_i18n" : {
					"zh-TW"
					"en-US"
				},
				"co_units"	: [
					{
						"co_unit_i18n"	: {
							"zh-TW"
							"en-US"
						},
						"provide_size"	: [
							"M", "S", "L"
						],
						"sites"	: [
							{
								"site_i118n"	: {
									"zh-TW"
									"en-US"
								},
								"site_no"		: "",
								"lockers_type"	: [
									{
										"size"	: "S",
		    							"total"	: 0,
		    							"empty"	: 0
									},
									{...}
								],
								"updated_at"	: "1990-01-01 00:00"
							}
						]
					}
				]
			},
			//中部地區
			{
				...
			}
		]
		*/
      filter_sites: [],
      //彈出視窗內容
      win_data: {
        lockers: {
          //視窗 title
          site_i18n: {
            'zh-TW': '',
            'en-US': '',
          },
          site_no: '',
        },
      },
      //暫存點擊的站點資訊
      click_site: null,
      //彈出視窗內無資料
      is_win_no_data: false,
      //強制顯示彈出視窗內的離線提示
      is_force_show_win_offline: false,
    };
  },
  computed: {
    //網路連線狀態 (頁面列表)
    is_offline: function () {
      return this.net_offline && this.is_no_data;
      // return false
    },
    is_no_data: function () {
      return !this.origin_sites || this.origin_sites.length <= 0;
      // return false
    },
    ...mapState({
      net_offline: (state) => state.is_offline,
    }),
  },
  beforeDestroy: function () {
    clearTimeout(this.wait_auto_paly_ad_timer);
  },
  mounted: function () {
    var ref = this;

    //動畫處理
    new WOW().init();

    //載入站點資訊
    this.vLoadSites();

    //廣告 n 秒後自動播放(但是若廣告 banner 沒有顯示，不設計時器)
    if ($('#loa').is(':visible') && !this.wait_auto_paly_ad_timer) {
      this.wait_auto_paly_ad_timer = setTimeout(function () {
        ref.ad_open = true;
      }, this.i_auto_paly_ad_after_sec);
    }
  },
  methods: {
    //網路連線狀態改變為 online 時觸發
    vNetworkOnline: function () {
      //從 cache / 網路載入站點資訊
      this.vLoadSites();
    },
    //網路連線狀態改變為 offline 時觸發
    vNetworkOffline: function () {},
    //關閉廣告播放
    vCloseAdBanner: function (ad_open) {
      this.ad_open = ad_open;
    },
    //讀取站點資料
    vLoadSites: function () {
      var ref = this;
      if (!this.locations_api || this.locations_api.length <= 0) {
        return;
      }
      // 從 chaches 取得
      Public.appGetOWLockerDataFromCache(this.locations_api).then((data) => {
        ref.vRenderLocations(data);
      });

      // 從網路取得
      Public.appGetOWLockerDataFromNetwork(this.locations_api).then((data) => {
        ref.vRenderLocations(data);
      });
    },
    vRenderLocations: function (locations_data) {
      var i = 0,
        j = 0;
      /*依前端需求重整副櫃尺寸代碼
		  後台 => S:充電櫃 / M:小櫃 / L:大櫃
		  前台 => M:充電櫃 / S:小櫃 / L:大櫃
		*/
      if (locations_data) {
        for (i = 0; i < locations_data.length; i++) {
          for (j = 0; j < locations_data[i]['sites'].length; j++) {
            for (
              var s = 0;
              s < locations_data[i]['sites'][j]['lockers_type'].length;
              s++
            ) {
              if (
                locations_data[i]['sites'][j]['lockers_type'][s]['size'] == 'M'
              ) {
                locations_data[i]['sites'][j]['lockers_type'][s]['size'] = 'S';
              } else if (
                locations_data[i]['sites'][j]['lockers_type'][s]['size'] == 'S'
              ) {
                locations_data[i]['sites'][j]['lockers_type'][s]['size'] = 'M';
              }
            }
          }
        }
      }
      //重置資料
      this.origin_sites =
        locations_data && locations_data.length > 0
          ? locations_data
          : this.origin_sites;
      //依 UI 需求，依副櫃尺寸排序資料
      for (i = 0; i < this.origin_sites.length; i++) {
        for (j = 0; j < this.origin_sites[i]['sites'].length; j++) {
          this.origin_sites[i]['sites'][j]['lockers_type'] = this.origin_sites[
            i
          ]['sites'][j]['lockers_type'].sort(function (a, b) {
            var a_sorted = Public.pbLockerTypeSort(a.size);
            var b_sorted = Public.pbLockerTypeSort(b.size);
            return a_sorted > b_sorted ? 1 : -1;
          });
        }
      }
      //從資料源中整理出 nav_co_units 的資料
      this.vLoadCoUnitsNav(this.origin_sites);
      //預設顯示 "全部" 站點資料
      this.vRefactorData(0);
    },
    //依 UI 需求整理 "地點導覽列" 資料
    vLoadCoUnitsNav: function (locations_data) {
      var i = 0;
      var key = '',
        i18n_key = '';
      //清除(但保留第1個element -> 全部)
      for (i = this.nav_co_units.length - 1; i > 0; i--) {
        this.nav_co_units.pop();
      }

      //重建
      for (i = 0; i < locations_data.length; i++) {
        for (key in locations_data[i]) {
          if (key == 'co_unit_i18n') {
            var co_unit = {};
            for (i18n_key in locations_data[i][key]) {
              co_unit[i18n_key] = locations_data[i][key][i18n_key];
            }
            co_unit['is_current'] = false;
            this.nav_co_units.push(co_unit);
          }
        }
      }
    },
    //依 UI 需求整理站點資料
    vRefactorData: function (nav_idx) {
      var key = '';
      this.filter_sites = [];

      for (var i_sort = 0; i_sort < this.list_sort.length; i_sort++) {
        var area_obj = {
          area_i18n: {},
          co_units: [],
        };
        for (var i = 0; i < this.origin_sites.length; i++) {
          //非指定合作單位的資料，濾掉不處理
          if (
            nav_idx > 0 &&
            this.nav_co_units[nav_idx]['zh-TW'] !=
              this.origin_sites[i]['co_unit_i18n']['zh-TW']
          ) {
            continue;
          }
          //合作單位
          var co_unit_obj = {
            co_unit_i18n: {},
            provide_size: [],
            sites: [],
          };
          for (key in this.origin_sites[i]['co_unit_i18n']) {
            co_unit_obj['co_unit_i18n'][key] =
              this.origin_sites[i]['co_unit_i18n'][key];
          }
          for (var j = 0; j < this.origin_sites[i]['sites'].length; j++) {
            if (
              this.origin_sites[i]['sites'][j]['area_i18n']['zh-TW'].indexOf(
                this.list_sort[i_sort]
              ) >= 0
            ) {
              //地區
              for (key in this.origin_sites[i]['sites'][j]['area_i18n']) {
                area_obj['area_i18n'][key] =
                  this.origin_sites[i]['sites'][j]['area_i18n'][key];
              }
              //提供櫃子尺寸
              for (
                var x = 0;
                x < this.origin_sites[i]['sites'][j]['lockers_type'].length;
                x++
              ) {
                if (
                  co_unit_obj['provide_size'].indexOf(
                    this.origin_sites[i]['sites'][j]['lockers_type'][x]['size']
                  ) < 0
                ) {
                  co_unit_obj['provide_size'].push(
                    this.origin_sites[i]['sites'][j]['lockers_type'][x]['size']
                  );
                }
              }
              //地點明細
              var site_obj = {};
              for (key in this.origin_sites[i]['sites'][j]) {
                if (key != 'area_i18n') {
                  site_obj[key] = this.origin_sites[i]['sites'][j][key];
                }
              }
              co_unit_obj['sites'].push(site_obj);
            }
          }
          if (co_unit_obj['sites'] && co_unit_obj['sites'].length > 0) {
            area_obj['co_units'].push(co_unit_obj);
          }
        }
        if (area_obj['co_units'] && area_obj['co_units'].length > 0) {
          this.filter_sites.push(area_obj);
        }
      }
    },
    //地點導覽列 focus 樣式變化
    vCoUnitsChangeFocus: function (new_focus_idx) {
      for (var i = 0; i < this.nav_co_units.length; i++) {
        this.nav_co_units[i]['is_current'] = false;
      }
      this.nav_co_units[new_focus_idx]['is_current'] = true;
    },
    //過濾指定位置資料
    vFilterSite: function (nav_idx) {
      this.vCoUnitsChangeFocus(nav_idx);
      //過濾資料
      this.vRefactorData(nav_idx);
      //Gtag Event
      this.$gtag.event('快速分類', {
        event_category: '空櫃/價格查詢',
        event_label: this.nav_co_units[nav_idx]['zh-TW'],
        value: 1,
      });
    },
    //準備據點詳細資訊視窗
    vReadyDetailWinContent: function (site) {
      this.click_site = site;
      this.$refs.qs_win.vLoadDetailSite(site);
      //Gtag Event
      this.$gtag.event('空箱數', {
        event_category: '空櫃/價格查詢',
        event_label: site['site_i18n']['zh-TW'],
        value: 1,
      });
    },
    //開啟據點詳細資訊視窗
    vOpenDetailWin: function () {
      this.open_win = true;
    },
    //關閉據點詳細資訊視窗
    vCloseDetailWin: function () {
      this.click_site = null;
      this.open_win = false;
      //復歸到第1個 tab
      $('ul.tab-title li:first').click();
    },
  },
  watch: {
    ad_open: function (new_val) {
      this.$refs.ad_banner.vToggleAdBanner(new_val);
    },
    net_offline: function (new_val) {
      if (new_val) {
        this.vNetworkOffline();
      } else {
        this.vNetworkOnline();
      }
    },
  },
};
</script>
